export const backgroundList = [
  "rgba(255,255,255,1)",
  "rgba(44,47,49,1)",
  "rgba(233, 216, 188,1)",
  "rgba(197, 231, 207,1)",
];
export const textList = [
  "rgba(0,0,0,1)",
  "rgba(255,255,255,1)",
  "rgba(89, 68, 41,1)",
  "rgba(54, 80, 62,1)",
];
export const themeList = [
  {
    id: 0,
    color: "rgba(75, 75, 75, 1)",
    name: "default",
    title: "Default",
  },
  {
    id: 1,
    color: "rgba(1, 121, 202, 1)",
    name: "blue",
    title: "Blue",
  },
  {
    id: 2,
    color: "rgba(0, 143, 145, 1)",
    name: "green",
    title: "Green",
  },

  {
    id: 3,
    color: "rgba(241, 100, 100, 1)",
    name: "red",
    title: "Red",
  },
  {
    id: 4,
    color: "rgba(104, 103, 209, 1)",
    name: "purple",
    title: "Purple",
  },
];
